//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1ReportsMaintenance from '@/apps/customer-insigths/components/somos1/Somos1ReportsMaintenance';
import RegionsMaintenanceComponent from '@/apps/customer-insigths/components/somos1/RegionsMaintenanceComponent';
import SectionsMaintenanceComponent from '@/apps/customer-insigths/components/somos1/SectionsMaintenanceComponent';
import UpdateHoursMaintenanceComponent from '@/apps/customer-insigths/components/somos1/UpdateHoursMaintenanceComponent';
import UsersMaintenanceComponent from '@/apps/customer-insigths/components/somos1/UsersMaintenanceComponent.vue';
import { TYPE_ELEMENTS, ROLES_LIST, GA_EVENTS } from '@/js/constants';
export default {
  name: 'CustomerInsightsMaintenancePage',
  components: {
    RegionsMaintenanceComponent: RegionsMaintenanceComponent,
    SectionsMaintenanceComponent: SectionsMaintenanceComponent,
    Somos1ReportsMaintenance: Somos1ReportsMaintenance,
    UpdateHoursMaintenanceComponent: UpdateHoursMaintenanceComponent,
    UsersMaintenanceComponent: UsersMaintenanceComponent
  },
  data: function data() {
    return {
      prefixRef: 'maintenanceComponent',
      tab: 0
    };
  },
  computed: {
    getCurrentRef: function getCurrentRef() {
      return "".concat(this.prefixRef, "-").concat(this.tab);
    },
    isInsishtsAdmin: function isInsishtsAdmin() {
      return window.userInfo.userRoles.includes(ROLES_LIST.INSIGHTS_ADMIN);
    }
  }
};